<scf-user-atributions
  *ngIf="dataSourceProfiles.data.length == 0"
  [isUpdate]="false"
  (save)="saveProfile($event)"
></scf-user-atributions>

<mat-card *ngIf="dataSourceProfiles.data.length > 0">
  <h2 translate>userProfileSingle.profiles</h2>
  <div class="table__wrapper">
    <table aria-label="profiles" mat-table [dataSource]="this.dataSourceProfiles.data">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef translate></th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsProfiles"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsProfiles"></tr>
    </table>
  </div>
</mat-card>
